import { context, trace } from '@dealroadshow/jsbro/OTel/api';
import Container from '@framework/di/Container';
import { IUseOTelTraceContext, OTelTraceContextSymbol } from './react/OTelTraceContext';

const OTelInstrument = <MethodCallback extends (...args: any) => Promise<any>>(
  object: any,
  methodName: string,
  container: Container,
  nameCallback?: (...args: Parameters<MethodCallback>) => string,
  optionsCallback: (...args: Parameters<MethodCallback>) => object = () => ({}),
) => {
  const originalCall = object[methodName];
  object[methodName] = (...args: any) => {
    // @ts-ignore
    let currentSpan = trace.getSpan(context.active());

    if (!currentSpan) {
      try {
        currentSpan = container.get<IUseOTelTraceContext>(OTelTraceContextSymbol).span;
      } catch (e) {
        // No active span
      }
    }

    // @ts-ignore
    const ctx = trace.setSpan(context.active(), currentSpan);

    const objectName = object.constructor.name;

    return trace.getTracer().startActiveSpan(
      nameCallback ? nameCallback(...args) : `${ objectName }.${ methodName }`,
      optionsCallback(...args),
      ctx,
      async (span) => {
        try {
          return await originalCall.bind(object)(...args);
        } catch (e) {
          span.recordException({ message: e instanceof Error ? e.message : String(e) });
          throw e;
        } finally {
          span.end();
        }
      },
    );
  };
};

export default OTelInstrument;
